import React from 'react';

// Existing controls extracted intact; all writes stay in the Planner handlers.
export default function PlannerCreateShiftPanel({ DEFAULT_ROLES, SHIFT_PRESETS, addDays, allowedRoles, applyPreset, calendarAnchorMs, calendarExpanded, cardStyle, createQty, handleCreateShift, isFlexibleCreate, isMobile, isTablet, newShiftEnd, newShiftMode, newShiftPreset, newShiftRole, newShiftStart, roleColorFor, schedulerConflictSummary, selectedDayMs, selectedWorkerUid, setCalendarAnchorMs, setCalendarExpanded, setCreateQty, setDateScope, setNewShiftEnd, setNewShiftMode, setNewShiftRole, setNewShiftStart, setSelectedDayMs, setSelectedDirectWorkerUids, setSelectedWorkerUid, startOfDayMs, visibleCalendarDays, workerPool, ymd }) {
 return (<div
              style={{
                ...cardStyle(),
                marginBottom: 14,
                background: "linear-gradient(180deg, rgba(255,255,255,.96) 0%, rgba(248,250,252,.96) 100%)",
                backdropFilter: "blur(10px)",
                border: "1px solid #d6e0eb",
                borderRadius: 20,
                boxShadow: "0 14px 34px rgba(15,23,42,.075)",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  padding: isMobile ? "12px 14px" : "14px 16px",
                  borderBottom: "1px solid #dbe4ee",
                  background: "linear-gradient(180deg,#ffffff 0%,#f8fafc 100%)",
                }}
              >
                <div
                  style={{
                    fontWeight: 950,
                    fontSize: 16,
                    letterSpacing: -0.15,
                    color: "#1d4ed8",
                    background: "#eff6ff",
                    border: "1px solid #bfdbfe",
                    borderRadius: 999,
                    padding: "7px 14px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}

                >
                  Create Shift
                </div>

                <div
                  style={{
                    color: "#334155",
                    fontSize: 12,
                    fontWeight: 800,
                    marginTop: 5,
                  }}
                >
                  Choose role, offer type, time and quantity. Existing eligibility and timing safeguards apply.
                </div>
              </div>

              <div style={{ padding: isMobile ? 10 : 12 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: isMobile ? "flex-start" : "center",
                    flexDirection: isMobile ? "column" : "row",
                    gap: 8,
                    marginBottom: 8,
                  }}
                >
                  <div style={{ color: "#0f172a", fontSize: 13, fontWeight: 950 }}>
                    {new Date(calendarAnchorMs).toLocaleDateString(undefined, {
                      month: "long",
                      year: "numeric",
                    })}
                  </div>

                  <div style={{ display: "flex", gap: 6 }}>
                    <button
                      className="calendarNavBtn"
                      onClick={() => {
                        const d = new Date(calendarAnchorMs);
                        d.setMonth(d.getMonth() - 1, 1);
                        d.setHours(0, 0, 0, 0);
                        setCalendarAnchorMs(d.getTime());
                        setCalendarExpanded(true);
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="calendarNavBtn"
                      onClick={() => {
                        const todayMs = startOfDayMs(Date.now());
                        setCalendarAnchorMs(todayMs);
                        setSelectedDayMs(todayMs);
                        setCalendarExpanded(false);
                        setDateScope("today");
                      }}
                      style={{
                        background: "#2563eb",
                        color: "#ffffff",
                        border: "1px solid #2563eb",
                        fontWeight: 900,
                        boxShadow: "0 8px 18px rgba(37,99,235,.24)",
                      }}
                    >
                      Today
                    </button>

                    <button
                      className="calendarNavBtn"
                      onClick={() => {
                        const d = new Date(calendarAnchorMs);
                        d.setMonth(d.getMonth() + 1, 1);
                        d.setHours(0, 0, 0, 0);
                        setCalendarAnchorMs(d.getTime());
                        setCalendarExpanded(true);
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>

                {calendarExpanded ? (
                  <div
                    style={{
                      marginBottom: 10,
                      display: "grid",
                      gridTemplateColumns: isMobile
                        ? "repeat(3, minmax(0, 1fr))"
                        : "repeat(auto-fit, minmax(74px, 1fr))",
                      gap: 6,
                    }}
                  >
                    {visibleCalendarDays.map((d) => {
                      const active = ymd(selectedDayMs) === d.key;

                      return (
                        <button
                          key={d.key}
                          onClick={() => {
  setSelectedDayMs(d.ms);

  const todayMs = startOfDayMs(Date.now());
  const tomorrowMs = addDays(todayMs, 1);

  if (d.ms === todayMs) {
    setDateScope("today");
  } else if (d.ms === tomorrowMs) {
    setDateScope("tomorrow");
  } else {
  setDateScope("today");
}
}}
                          className={`dayTab ${active ? "dayTabActive" : ""}`}
                          style={{
                            textAlign: "left",
                            padding: "8px 10px",
                            minHeight: 52,
                            borderRadius: 13,
                            border: active ? "1px solid #2563eb" : "1px solid #dbe4ee",
                            background: active ? "#2563eb" : "#ffffff",
                            color: active ? "#ffffff" : "#0f172a",
                            boxShadow: active
                              ? "0 8px 18px rgba(37,99,235,.25)"
                              : "0 2px 6px rgba(15,23,42,.03)",
                          }}
                        >
                          <div style={{ fontWeight: 950, fontSize: 12 }}>{d.label}</div>
                          <div
                            style={{
                              fontSize: 11,
                              fontWeight: 850,
                              color: active ? "#dbeafe" : "#475569",
                              marginTop: 2,
                            }}
                          >
                            {d.dateLabel}
                          </div>
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      marginBottom: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 10,
                      padding: "8px 12px",
                      borderRadius: 14,
                      border: "1px solid #bfdbfe",
                      background: "linear-gradient(90deg,#1d4ed8,#2563eb)",
                      boxShadow: "0 10px 22px rgba(37,99,235,.22)",
                      color: "#ffffff",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 950 }}>
                        {new Date(selectedDayMs).toLocaleDateString(undefined, {
                          weekday: "short",
                        })}
                      </div>
                      <div style={{ fontSize: 11, fontWeight: 850, color: "#dbeafe" }}>
                        {new Date(selectedDayMs).toLocaleDateString(undefined, {
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn"
                      onClick={() => setCalendarExpanded(true)}
                      style={{
                        borderRadius: 999,
                        padding: "6px 12px",
                        fontSize: 11,
                        fontWeight: 900,
                        background: "rgba(255,255,255,.95)",
                        border: "1px solid rgba(255,255,255,.8)",
                        color: "#1d4ed8",
                      }}
                    >
                      Open calendar
                    </button>
                  </div>
                )}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "1fr"
                      : isTablet
                        ? "repeat(3, minmax(0, 1fr))"
                        : "repeat(auto-fit, minmax(150px, 1fr))",
                    gap: 8,
                    alignItems: "center",
                    padding: 10,
                    borderRadius: 18,
                    background: "linear-gradient(180deg,#ffffff 0%,#f3f6fa 100%)",
                    border: "1px solid #dbe4ee",
                    boxShadow: "inset 0 1px 0 rgba(255,255,255,.8), 0 4px 12px rgba(15,23,42,.035)",
                  }}
                >
                  <select
                    aria-label="Worker role"
                    value={newShiftRole}
                    onChange={(e) => setNewShiftRole(e.target.value)}
                    className="input"
                    style={{
                      height: 40,
                      fontSize: 13,
                      fontWeight: 900,
                      color: roleColorFor(newShiftRole).color,
                      borderColor: `${roleColorFor(newShiftRole).color}40`,
                      background: `${roleColorFor(newShiftRole).color}0f`,
                      borderRadius: 12,
                    }}
                  >
                    {(allowedRoles.length ? allowedRoles : DEFAULT_ROLES).map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>

                  <select
                    aria-label="Offer type"
                    value={newShiftMode}
                    onChange={(e) => setNewShiftMode(e.target.value)}
                    className="input"
                    style={{
                      height: 40,
                      fontSize: 13,
                      fontWeight: 900,
                      color: newShiftMode === "direct" ? "#9a3412" : "#1d4ed8",
                      borderColor: newShiftMode === "direct" ? "#fdba74" : "#93c5fd",
                      background: newShiftMode === "direct" ? "#fff7ed" : "#eff6ff",
                      borderRadius: 12,
                    }}
                  >
                    <option value="pool">Pool</option>
                    <option value="direct">Direct</option>
                  </select>

                  <select
                    aria-label="Shift preset"
                    value={newShiftPreset}
                    onChange={(e) => applyPreset(e.target.value)}
                    className="input"
                    style={{
                      height: 40,
                      fontSize: 13,
                      fontWeight: 850,
                      color: "#334155",
                      borderColor: isFlexibleCreate ? "#facc15" : "#cbd5e1",
                      background: isFlexibleCreate ? "#fef9c3" : "#ffffff",
                      borderRadius: 12,
                    }}
                  >
                    {SHIFT_PRESETS.map((p) => (
                      <option key={p.key} value={p.key}>
                        {p.label}
                      </option>
                    ))}
                  </select>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 110px", gap: 6 }}>
                    <input
                      className="input"
                      aria-label="Shift start date" type = "date"
                      value={newShiftStart ? newShiftStart.slice(0, 10) : ymd(selectedDayMs)}
                      onChange={(e) => {
                        const time = newShiftStart?.slice(11, 16) || "06:00";
                        setNewShiftStart(`${e.target.value}T${time}`);
                      }}
                      style={{
                        height: 40,
                        fontSize: 13,
                        borderRadius: 12,
                        background: "#ffffff",
                        borderColor: isFlexibleCreate ? "#facc15" : "#cbd5e1",
                      }}
                    />

                    <input
                      className="input"
                      aria-label="Shift start time" type = "time"
                      value={newShiftStart ? newShiftStart.slice(11, 16) : "06:00"}
                      onChange={(e) => {
                        const date = newShiftStart?.slice(0, 10) || ymd(selectedDayMs);
                        setNewShiftStart(`${date}T${e.target.value}`);
                      }}
                      style={{
                        height: 40,
                        fontSize: 13,
                        borderRadius: 12,
                        background: "#ffffff",
                        borderColor: isFlexibleCreate ? "#facc15" : "#cbd5e1",
                      }}
                    />
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 110px", gap: 6 }}>
                    <input
                      className="input"
                      aria-label="Shift end date" type = "date"
                      value={newShiftEnd ? newShiftEnd.slice(0, 10) : ymd(selectedDayMs)}
                      onChange={(e) => {
                        const time = newShiftEnd?.slice(11, 16) || "14:00";
                        setNewShiftEnd(`${e.target.value}T${time}`);
                      }}
                      style={{
                        height: 40,
                        fontSize: 13,
                        borderRadius: 12,
                        background: "#ffffff",
                        borderColor: isFlexibleCreate ? "#facc15" : "#cbd5e1",
                      }}
                    />

                    <input
                      className="input"
                      aria-label="Shift end time" type = "time"
                      value={newShiftEnd ? newShiftEnd.slice(11, 16) : "14:00"}
                      onChange={(e) => {
                        const date = newShiftEnd?.slice(0, 10) || ymd(selectedDayMs);
                        setNewShiftEnd(`${date}T${e.target.value}`);
                      }}
                      style={{
                        height: 40,
                        fontSize: 13,
                        borderRadius: 12,
                        background: "#ffffff",
                        borderColor: isFlexibleCreate ? "#facc15" : "#cbd5e1",
                      }}
                    />
                  </div>

                  {isFlexibleCreate ? (
                    <div
                      style={{
                        gridColumn: isMobile ? "auto" : "span 3",
                        minHeight: 34,
                        borderRadius: 12,
                        border: "1px solid #facc15",
                        background: "#fef9c3",
                        color: "#854d0e",
                        display: "flex",
                        alignItems: "center",
                        padding: "7px 12px",
                        fontSize: 12,
                        fontWeight: 900,
                        lineHeight: 1.25,
                      }}
                    >
                      Emergency fill — select the real start and end time before publishing.
                    </div>
                  ) : null}

                  <select
                    aria-label="Direct offer worker"
                    value={selectedWorkerUid}
                    onChange={(e) => {
                      setSelectedWorkerUid(e.target.value);
                      setSelectedDirectWorkerUids(e.target.value ? [e.target.value] : []);
                    }}
                    className="input"
                    style={{
                      height: 40,
                      fontSize: 13,
                      fontWeight: 800,
                      color: String(newShiftMode).toLowerCase() === "direct" ? "#0f172a" : "#94a3b8",
                      borderColor: String(newShiftMode).toLowerCase() === "direct" ? "#d8e1ea" : "#e5e7eb",
                      background: String(newShiftMode).toLowerCase() === "direct" ? "#ffffff" : "#f8fafc",
                      borderRadius: 12,
                    }}
                    disabled={String(newShiftMode).toLowerCase() !== "direct"}
                    title={
                      String(newShiftMode).toLowerCase() === "direct"
                        ? "Choose worker"
                        : "Worker selection is for Direct mode only"
                    }
                  >
                    <option value="">
                      {String(newShiftMode).toLowerCase() === "direct"
                        ? "Select worker…"
                        : "Worker (direct only)"}
                    </option>
                  {workerPool.map((w) => {
  const credential =
    w.positions?.[0] ||
    w.workerType ||
    w.position ||
    w.primaryRole ||
    w.roleCode ||
    "WORKER";

  return (
    <option key={w.uid} value={w.uid}>
      {w.email || w.uid} — {credential}
    </option>
  );
})}
                  </select>

                  <input
                    className="input"
                    type="number" aria-label="Shift quantity"
                    min="1"
                    max="50"
                    value={createQty}
                    onChange={(e) => setCreateQty(e.target.value)}
                    disabled={String(newShiftMode).toLowerCase() === "direct"}
                    style={{
                      height: 40,
                      fontSize: 13,
                      textAlign: "center",
                      fontWeight: 900,
                      color: "#0f172a",
                      borderColor: "#cbd5e1",
                      background: String(newShiftMode).toLowerCase() === "direct" ? "#f8fafc" : "#ffffff",
                      borderRadius: 12,
                    }}
                  />

                  <button
                    className="btn btnPrimary"
                    style={{
                      height: 40,
                      fontSize: 13,
                      fontWeight: 950,
                      borderRadius: 12,
                      background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
                      color: "#ffffff",
                      border: "none",
                      boxShadow: "0 12px 24px rgba(29,78,216,.28)",
                    }}
                    onClick={() => handleCreateShift(false)}
                    disabled={!!schedulerConflictSummary}
                  >
                    {String(newShiftMode).toLowerCase() === "direct"
                      ? "Create Offer"
                      : `Create ${Math.max(1, Number(createQty || 1))}`}
                  </button>

                  <button
                    className="btn"
                    style={{
                      height: 40,
                      fontSize: 12,
                      fontWeight: 950,
                      borderRadius: 12,
                      background: "#ecfeff",
                      color: "#0e7490",
                      border: "1px solid #67e8f9",
                    }}
                    onClick={() => handleCreateShift(true)}
                    disabled={!!schedulerConflictSummary}
                  >
                    Auto Assign
                  </button>
                </div>

                {schedulerConflictSummary ? (
                  <div
                    style={{
                      marginTop: 8,
                      color: "#b91c1c",
                      fontWeight: 850,
                      fontSize: 12,
                      padding: "8px 10px",
                      borderRadius: 12,
                      background: "#fff1f2",
                      border: "1px solid #fecdd3",
                    }}
                  >
                    {schedulerConflictSummary}
                  </div>
                ) : null}
              </div>
            </div>);
}
